import React from 'react';
import ReactDOM from 'react-dom';
import { Typography } from '@wearesection/raise-ui/atoms';

function ReactRenderHeadingBlock() {
	const raiseHeadingBlocks = Array.from( document.querySelectorAll( '.raise-heading' ) ) as HTMLElement[];
	raiseHeadingBlocks?.length > 0 &&
		raiseHeadingBlocks.forEach( ( element: HTMLElement ) => {
			let className = element?.getAttribute( 'class' ) as string;
			const tagName = element?.firstElementChild?.tagName?.toLowerCase() as string;
			const htmlContent = element?.children?.[ 0 ]?.innerHTML;
			const childrenClass = element?.children?.[ 0 ]?.getAttribute( 'class' ) as string;
			if (childrenClass) {
				className = `${className} ${childrenClass}`
			}
			ReactDOM.render(
				<Typography component={ tagName } className={ className } noVariant>
					<p dangerouslySetInnerHTML={ { __html: htmlContent } } />
				</Typography>,
				element,
			);
		} );
}

export default ReactRenderHeadingBlock;
